import { forwardRef, ReactElement } from 'react';
import { Icon, IconBase, IconWeight } from '@phosphor-icons/react';

const weights = new Map<IconWeight, ReactElement>([
    [
        'regular',
        <>
            <path d="M93.5,192.4c0,21.4-17.4,38.8-38.8,38.8h-17.2c-4.8,0-8.6-3.9-8.6-8.6v-60.3c0-4.8,3.9-8.6,8.6-8.6h17.2c21.4,0,38.8,17.4,38.8,38.8ZM76.3,192.4c0-11.9-9.6-21.5-21.5-21.5h-8.6v43.1h8.6c11.9,0,21.5-9.6,21.5-21.5Z" />
            <path d="M145.1,231h-34.2c-4.7,0-8.5-3.8-8.5-8.5v-60.3c0-4.7,3.8-8.5,8.5-8.5s8.5,3.8,8.5,8.5v51.8h25.7c4.7,0,8.5,3.8,8.5,8.5s-3.8,8.5-8.5,8.5Z" />
            <path d="M188.3,153.6h-17.2c-4.8,0-8.6,3.9-8.6,8.6v60.3c0,4.8,3.9,8.6,8.6,8.6s8.6-3.9,8.6-8.6v-8.6h8.6c16.7,0,30.2-13.5,30.2-30.2s-13.5-30.2-30.2-30.2ZM188.3,196.7h-8.6v-25.8h8.6c7.1,0,12.9,5.8,12.9,12.9s-5.8,12.9-12.9,12.9Z" />
            <path d="M99.5,128.1h0c-2.3,0-4.4-.9-6-2.5l-30.1-30.1c-3.3-3.3-3.3-8.7,0-12s8.7-3.3,12,0l24.1,24.1L180,27.1c3.3-3.3,8.7-3.3,12,0,3.3,3.3,3.3,8.7,0,12l-86.4,86.4c-1.6,1.6-3.8,2.5-6,2.5Z" />
        </>,
    ],
]);

const DlpActive: Icon = forwardRef((props, ref) => <IconBase ref={ref} {...props} weights={weights} />);

DlpActive.displayName = 'DlpActive';

export default DlpActive;
